import type { KenhDoiSoat } from '@qlk/shared';
import { VAI_TRO_CHIA_LABEL } from '@qlk/shared';

import { StatusBadge, dinhDangTien } from '../../../ui/index.js';

export interface BangDoiSoatKenhProps {
  theoKenh: KenhDoiSoat[];
  /** Hiện cột kỳ khi đang xem quý (một kênh có ba dòng). */
  hienCotKy: boolean;
}

/**
 * Đối soát theo kênh: một dòng cho mỗi **kênh × kỳ**.
 *
 * Xem theo quý thì một kênh có ba dòng, vì thực nhận và chi phí của từng tháng
 * khác nhau — gộp lại thành một dòng là mất chỗ duy nhất giải thích được tại sao
 * tháng nào đó chia ít hơn.
 */
export function BangDoiSoatKenh({ theoKenh, hienCotKy }: BangDoiSoatKenhProps) {
  return (
    <div className="overflow-x-auto rounded-the border border-vien bg-be-mat">
      <table className="w-full min-w-[980px] border-collapse text-co-ban">
        <thead>
          <tr className="bg-header-bang text-left text-tieu-de-cot font-semibold text-chu-phu">
            <th className="px-3 py-3">Kênh</th>
            {hienCotKy && <th className="px-3 py-3">Kỳ</th>}
            <th className="px-3 py-3">Nhóm</th>
            <th className="px-3 py-3 text-right">Thực nhận</th>
            <th className="px-3 py-3 text-right">Chi phí</th>
            <th className="px-3 py-3 text-right">Lợi nhuận</th>
            <th className="px-3 py-3 text-right">Cơ sở chia</th>
            <th className="px-3 py-3">Đội ngũ được chia</th>
            <th className="px-3 py-3 text-right">Phần chia</th>
            <th className="px-3 py-3 text-right">Công ty giữ</th>
          </tr>
        </thead>
        <tbody>
          {theoKenh.map((k) => (
            <tr key={`${k.channelId}-${k.period}`} className="border-t border-vien align-top">
              <td className="px-3 py-3">
                <span className="font-medium text-chu">{k.tenKenh}</span>
                {k.kenhLo && (
                  <span className="ml-2">
                    <StatusBadge tone="warn">Kênh lỗ</StatusBadge>
                  </span>
                )}
                {k.ngayBatDauVanHanh === null && (
                  <span
                    className="ml-2"
                    title="Chi phí đang bị trừ toàn bộ vì chưa tách được khoản trước ngày vận hành"
                  >
                    <StatusBadge tone="warn">Chưa đặt ngày vận hành</StatusBadge>
                  </span>
                )}
              </td>
              {hienCotKy && <td className="px-3 py-3 tabular-nums text-chu-phu">{k.period}</td>}
              <td className="px-3 py-3 text-phu text-chu-phu">{k.tenNhom ?? 'Chưa gán nhóm'}</td>
              <td className="px-3 py-3 text-right tabular-nums">{dinhDangTien(k.thucNhan)}</td>
              <td className="px-3 py-3 text-right tabular-nums">{dinhDangTien(k.chiPhiVanHanh)}</td>
              <td
                className={`px-3 py-3 text-right tabular-nums ${k.loiNhuan < 0 ? 'text-bad-chu' : ''}`}
              >
                {dinhDangTien(k.loiNhuan)}
              </td>
              <td className="px-3 py-3 text-right tabular-nums">
                {dinhDangTien(k.coSoChia)}
                {k.chiaTheoThucNhan && (
                  <span className="block text-phu text-warn-chu">theo thực nhận</span>
                )}
              </td>
              <td className="px-3 py-3 text-phu text-chu-phu">
                {k.dong.length === 0
                  ? '—'
                  : [
                      ...new Set(
                        k.dong.map((d) => `${d.tenNguoi} (${VAI_TRO_CHIA_LABEL[d.vaiTro]})`),
                      ),
                    ].join(' · ')}
              </td>
              <td className="px-3 py-3 text-right tabular-nums">{dinhDangTien(k.phanChia)}</td>
              <td
                className={`px-3 py-3 text-right font-semibold tabular-nums ${
                  k.congTyGiu < 0 ? 'text-bad-chu' : ''
                }`}
              >
                {dinhDangTien(k.congTyGiu)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
